/* eslint-disable enforce-ids-in-jsx/missing-ids */
import React from 'react'

import {
  StaticTag,
  TriggerDetailsContainer,
  TriggerDetailsDivider,
  TriggerDetailsLabel,
} from '../styles'

import RiskMeter from './RiskMeter'
import SourceBadgeList from './SourceBadgeList'

const TriggerDetails = ({ campaignId, level, sourcesByKind, sourceKindsToRender }) => (
  <TriggerDetailsContainer
    id={`Psima_Dashboard_TriggerDetails_div-${campaignId}`}
    data-testid={`Psima_Dashboard_TriggerDetails_div-${campaignId}`}
  >
    <TriggerDetailsLabel>Trigger details:</TriggerDetailsLabel>
    <RiskMeter campaignId={campaignId} level={level} />
    <TriggerDetailsDivider />
    <StaticTag
      id={`Psima_Dashboard_OsintTag_div-${campaignId}`}
      data-testid={`Psima_Dashboard_OsintTag_div-${campaignId}`}
    >
      OSINT
    </StaticTag>
    {!!sourceKindsToRender.length && (
      <>
        <TriggerDetailsDivider />
        <SourceBadgeList
          campaignId={campaignId}
          sourcesByKind={sourcesByKind}
          sourceKindsToRender={sourceKindsToRender}
        />
      </>
    )}
  </TriggerDetailsContainer>
)

export default TriggerDetails
